import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { SystemService } from './service/system-service.service';
import { Store } from '@ngrx/store';
import { selectIsGloballyAdmin } from '../authentication/store/user.selector';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard  {
  constructor(
    private systemService: SystemService,
    private router: Router,
    private store: Store
  ) {}

  canActivate(): Observable<boolean> {
    return this.checkMaintenanceMode();
  }

  canActivateChild(): Observable<boolean> {
    return this.checkMaintenanceMode();
  }

  checkMaintenanceMode(): Observable<boolean> {
    return combineLatest([
      this.systemService.getMaintenanceStatus(),
      this.store.select(selectIsGloballyAdmin)
    ]).pipe(
      map(([isMaintenance, isAdmin]) => {
        if (isMaintenance && !isAdmin) {
          this.router.navigate(['/maintenance']);
          return false;
        }
        return true;
      })
    );
  }
}
